import React, { useState } from 'react';
import './BedConfigurator.css';

type Props = {
  onCreateBed: (width: number, height: number, name: string) => void;
};

const clamp = (n: number) => Math.min(10, Math.max(1, n));

export default function BedConfigurator({ onCreateBed }: Props) {
  const [width, setWidth] = useState('4');
  const [height, setHeight] = useState('4');
  const [name, setName] = useState('');

  const widthNum = parseInt(width, 10) || 0;
  const heightNum = parseInt(height, 10) || 0;
  const area = widthNum * heightNum;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreateBed(clamp(widthNum || 1), clamp(heightNum || 1), name.trim() || 'My Garden Bed');
  };

  return (
    <div className="configurator">
      <div className="configurator__hero">
        <span className="configurator__icon">🌱</span>
        <h1 className="configurator__title">Plant Your Square Foot Garden</h1>
        <p className="configurator__subtitle">
          Set the size of your bed in feet, then fill it with plants!
        </p>
      </div>
      <form className="configurator__form" onSubmit={handleSubmit}>
        <label className="configurator__label configurator__label--full">
          <span>Bed name</span>
          <input
            type="text"
            className="configurator__input configurator__input--text"
            placeholder="e.g. Front raised bed, Veg patch A…"
            value={name}
            onChange={e => setName(e.target.value)}
            maxLength={40}
          />
        </label>
        <div className="configurator__inputs">
          <label className="configurator__label">
            <span>Width (ft)</span>
            <input
              type="number"
              className="configurator__input"
              min={1}
              max={10}
              value={width}
              onChange={e => setWidth(e.target.value)}
              onBlur={() => setWidth(String(clamp(widthNum || 1)))}
            />
          </label>
          <span className="configurator__x">×</span>
          <label className="configurator__label">
            <span>Height (ft)</span>
            <input
              type="number"
              className="configurator__input"
              min={1}
              max={10}
              value={height}
              onChange={e => setHeight(e.target.value)}
              onBlur={() => setHeight(String(clamp(heightNum || 1)))}
            />
          </label>
        </div>
        <p className="configurator__preview">
          That's <strong>{area}</strong> square {area === 1 ? 'foot' : 'feet'} of growing space
        </p>
        <button className="configurator__btn" type="submit">
          Create my bed 🌿
        </button>
      </form>
    </div>
  );
}
